// frontend/clubvip/src/club-vip/components/admin-view/Navigator.tsx
import * as React from "react";
import Divider from "@mui/material/Divider";
import Drawer, { DrawerProps } from "@mui/material/Drawer";
import List from "@mui/material/List";
import Box from "@mui/material/Box";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import HomeIcon from "@mui/icons-material/Home";
import PeopleIcon from "@mui/icons-material/People";
import LogoutIcon from "@mui/icons-material/Logout";
import { CardMedia, MenuItem } from "@mui/material";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import MapIcon from "@mui/icons-material/Map";
import { Link } from "react-router-dom";
import { useTheme, useMediaQuery } from "@mui/material";

import { useAppDispatch } from "../../hooks";
import { menuSelected } from "./navigatorSlice";
import { black, gold, white } from "../../getLPTheme";

const categories = [
  { id: "Métricas Generales", icon: <LeaderboardIcon />, active: false },
  { id: "Agregar Nuevo Punto", icon: <MapIcon /> },
  { id: "Gestionar Usuarios", icon: <ManageAccountsIcon /> },
  { id: "Editar Perfil", icon: <ManageAccountsIcon /> },
];

const item = {
  py: "2px",
  px: 3,
  color: white[50],
  "&:hover, &:focus": {
    bgcolor: gold[500],
    color: black[1000],
  },
};

const itemCategory = {
  boxShadow: "0 -1px 0 black[1000] inset",
  py: 1.5,
  px: 3,
};

type NavigatorProps = DrawerProps & {
  /**
   * Callback opcional para cerrar el drawer en mobile
   * (el padre lo pasa como: () => setMobileOpen(false))
   */
  onNavigate?: () => void;
};

export default function Navigator(props: NavigatorProps) {
  const { onNavigate, ...other } = props;

  const dispatch = useAppDispatch();

  // Detectar "mobile" (xs/sm). Podés ajustar el breakpoint si querés.
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const closeIfMobile = React.useCallback(() => {
    if (isMobile) onNavigate?.();
  }, [isMobile, onNavigate]);

  const handleLogout = async () => {
    localStorage.removeItem("CLUB-VIP-JWT");
    localStorage.removeItem("CLUB-VIP-AVATAR");
    localStorage.removeItem("CLUB-VIP-USER");
    closeIfMobile();
  };

  return (
    <Drawer variant="permanent" {...other}>
      <List disablePadding>
        <ListItem
          sx={{
            py: "2px",
            px: 3,
            ...itemCategory,
            fontSize: 15,
            color: black[1000],
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Box sx={{ px: 0 }}>
              <MenuItem>
                <Link to={"/"} style={{ textDecoration: "none" }} onClick={closeIfMobile}>
                  <CardMedia
                    component="img"
                    image={"images/logoWorldGolfClubWhite.png"}
                    sx={{ width: 150, height: 50 }}
                  />
                </Link>
              </MenuItem>
            </Box>
          </Box>
        </ListItem>

        <ListItem>
          <ListItemIcon sx={{ color: white[50] }}>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText sx={{ color: white[50] }}>MENU</ListItemText>
        </ListItem>

        <Box key="Administrador" sx={{ bgcolor: black[1000] }}>
          <ListItem sx={{ py: 2, px: 3 }}>
            <ListItemText sx={{ color: white[50] }}>Menu</ListItemText>
          </ListItem>

          <ListItem disablePadding key="Administrador">
            <Box sx={{ py: "2px", px: 3, color: gold[500] }}>
              <ListItemIcon>
                <PeopleIcon sx={{ mx: 1 }} />
                Administrador
              </ListItemIcon>
            </Box>
          </ListItem>

          <Divider sx={{ mt: 2 }} />
        </Box>

        <Box sx={{ bgcolor: black[1000] }}>
          {categories.map(({ id: childId, icon, active }) => (
            <ListItem disablePadding key={childId}>
              <ListItemButton
                selected={active}
                sx={item}
                onClick={() => {
                  dispatch(menuSelected(childId));
                  closeIfMobile();
                }}
              >
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText>{childId}</ListItemText>
              </ListItemButton>
            </ListItem>
          ))}

          <Link to={"/login"} style={{ textDecoration: "none" }} onClick={handleLogout}>
            <ListItem disablePadding>
              <ListItemButton sx={item}>
                <ListItemIcon>
                  <LogoutIcon />
                </ListItemIcon>
                <ListItemText>Cerrar Sesión</ListItemText>
              </ListItemButton>
            </ListItem>
          </Link>

          <Divider sx={{ mt: 2 }} />
        </Box>
      </List>
    </Drawer>
  );
}
